import { CountdownInterface } from 'common/types/entities/CountdownInterface'
import { CountdownTypesEnum } from '../enums/CountdownTypesEnum'

export const getFixedTime = (
  fixed: CountdownInterface[CountdownTypesEnum.fixed],
) => new Date(fixed.date).getTime()
